export enum TemperatureUnitsEnum {
    // celsius = 'CELSIUS',
    // fahrenheit = 'FAHRENHEIT',
    celsius = 'C',
    fahrenheit = 'F',
    //...
}
